export const SAS_SKI_TREE_ID = 'sas_ski_tree_v1';

export const SAS_SKI_TREE_SKILLS = [
  {
    skillId: 'sas_ski_balanced_stance',
    treeId: SAS_SKI_TREE_ID,
    name: 'Balanced stance',
    sport: 'skiing',
    discipline: 'all-mountain',
    groupType: 'foundational skills',
    levelGroup: 'beginner_foundations',
    description: 'Maintain a centered, athletic stance that supports balance and movement through the turn.',
    parentSkills: [],
    tags: ['stance', 'balance', 'posture', 'alignment'],
    focusAreas: ['stance', 'balance', 'alignment'],
    relatedDrillIds: ['ski_balance_stance_001_hands_forward'],
    sourceType: 'sas_tree',
    sourceLabel: 'SAS Ski Tree',
  },
  {
    skillId: 'sas_ski_turn_initiation_timing',
    treeId: SAS_SKI_TREE_ID,
    name: 'Turn initiation timing',
    sport: 'skiing',
    discipline: 'all-mountain',
    groupType: 'progression skills',
    levelGroup: 'early_parallel',
    description: 'Release the old turn and guide the skis into the new direction at the right moment.',
    parentSkills: ['sas_ski_balanced_stance'],
    tags: ['turn initiation', 'release', 'transition'],
    focusAreas: ['release', 'transition', 'turn initiation'],
    relatedDrillIds: ['ski_turn_initiation_001_garland_turns', 'ski_turn_initiation_001_sideslip_release'],
    sourceType: 'sas_tree',
    sourceLabel: 'SAS Ski Tree',
  },
  {
    skillId: 'sas_ski_edge_engagement_timing',
    treeId: SAS_SKI_TREE_ID,
    name: 'Edge engagement timing',
    sport: 'skiing',
    discipline: 'all-mountain',
    groupType: 'progression skills',
    levelGroup: 'parallel_skier',
    description: 'Build edge grip progressively and at the right point in the turn.',
    parentSkills: ['sas_ski_turn_initiation_timing'],
    tags: ['edging', 'edge grip', 'carving'],
    focusAreas: ['edging', 'edge grip', 'pressure control'],
    relatedDrillIds: ['ski_edging_basics_001_j_tracks', 'ski_turn_initiation_001_sideslip_release'],
    sourceType: 'sas_tree',
    sourceLabel: 'SAS Ski Tree',
  },
  {
    skillId: 'sas_ski_pressure_control',
    treeId: SAS_SKI_TREE_ID,
    name: 'Pressure control',
    sport: 'skiing',
    discipline: 'all-mountain',
    groupType: 'progression skills',
    levelGroup: 'parallel_skier',
    description: 'Manage pressure and weight transfer through the shaping and finish of the turn.',
    parentSkills: ['sas_ski_balanced_stance', 'sas_ski_turn_initiation_timing'],
    tags: ['pressure', 'weight shift', 'weight transfer'],
    focusAreas: ['pressure control', 'weight transfer', 'timing'],
    relatedDrillIds: ['ski_edging_basics_001_j_tracks'],
    sourceType: 'sas_tree',
    sourceLabel: 'SAS Ski Tree',
  },
  {
    skillId: 'sas_ski_turn_shape_control',
    treeId: SAS_SKI_TREE_ID,
    name: 'Turn shape control',
    sport: 'skiing',
    discipline: 'all-mountain',
    groupType: 'advanced / terrain skills',
    levelGroup: 'advanced_all_mountain',
    description: 'Adjust turn shape and timing intentionally to match terrain and speed demands.',
    parentSkills: ['sas_ski_turn_initiation_timing', 'sas_ski_edge_engagement_timing'],
    tags: ['turn shape', 'line choice', 'control'],
    focusAreas: ['turn shape', 'steering', 'terrain adaptation'],
    relatedDrillIds: ['ski_turn_initiation_001_garland_turns'],
    sourceType: 'sas_tree',
    sourceLabel: 'SAS Ski Tree',
  },
  {
    skillId: 'sas_ski_terrain_adaptation',
    treeId: SAS_SKI_TREE_ID,
    name: 'Terrain adaptation',
    sport: 'skiing',
    discipline: 'all-mountain',
    groupType: 'advanced / terrain skills',
    levelGroup: 'expert_technical_terrain',
    description: 'Apply strong movement patterns across steeps, variable snow, and more technical terrain.',
    parentSkills: ['sas_ski_turn_shape_control', 'sas_ski_pressure_control'],
    tags: ['terrain', 'steeps', 'variable snow', 'all mountain'],
    focusAreas: ['terrain adaptation', 'line choice', 'pressure control'],
    relatedDrillIds: [],
    sourceType: 'sas_tree',
    sourceLabel: 'SAS Ski Tree',
  },
];

export function getSasSkiTreeSkills() {
  return SAS_SKI_TREE_SKILLS;
}
